<div class="pxo-main-div">
  <app-version-change-popup></app-version-change-popup>

  <app-header></app-header>

  <app-wheel class="scroll-style"></app-wheel>
</div>
